import ClinicSchedule from "./clinic_schedule";

export default ClinicSchedule;
